/**
 * All Publications Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initAllPublications() {
    const blocks = document.querySelectorAll(".all-publications");

    blocks.forEach((block) => {
      const categorySelect = block.querySelector(
        '.filter-select[data-filter-type="category"]'
      );
      const yearSelect = block.querySelector(
        '.filter-select[data-filter-type="year"]'
      );
      const regionSelect = block.querySelector(
        '.filter-select[data-filter-type="region"]'
      );
      const postsContainer = block.querySelector(".posts");
      const loadMoreButton = block.querySelector(".load-more-button");
      const loadMoreWrapper = block.querySelector(".load-more-wrapper");

      if (!postsContainer) {
        return;
      }

      // Track current state
      let currentOffset = 0;
      let currentCategory = "";
      let currentYear = "";
      let currentRegion = "";
      const postsPerPage =
        parseInt(postsContainer.getAttribute("data-posts-per-page")) || 9;

      // Store initial offset - set to number of posts already displayed
      const initialPostsCount = postsContainer.querySelectorAll(".news_post").length;
      postsContainer.setAttribute("data-current-offset", initialPostsCount.toString());

      // Handle category change (only if category select exists)
      if (categorySelect) {
        categorySelect.addEventListener("change", function () {
          // Clear year and region selects when category is selected
          if (this.value) {
            if (yearSelect) yearSelect.value = "";
            if (regionSelect) regionSelect.value = "";
          }
          currentCategory = this.value;
          currentYear = "";
          currentRegion = "";
          currentOffset = 0;
          postsContainer.setAttribute("data-current-offset", "0");
          filterPublications(
            block,
            postsContainer,
            loadMoreWrapper,
            currentCategory,
            currentYear,
            currentRegion,
            "",
            currentOffset,
            postsPerPage,
            true
          );
          // Reset offset after replacing content
          const newPostsCount = postsContainer.querySelectorAll(".news_post").length;
          postsContainer.setAttribute("data-current-offset", newPostsCount.toString());
        });
      }

      // Helper: get effective category (from select or data-category when on category archive)
      const getEffectiveCategory = () =>
        categorySelect && categorySelect.value
          ? categorySelect.value
          : postsContainer.getAttribute("data-category") || "";

      // Handle year change (only if year select exists)
      if (yearSelect) {
        yearSelect.addEventListener("change", function () {
          // Clear category and region selects when year is selected (only if category select exists)
          if (this.value) {
            if (categorySelect) categorySelect.value = "";
            if (regionSelect) regionSelect.value = "";
          }
          currentCategory = getEffectiveCategory();
          currentYear = this.value;
          currentRegion = "";
          currentOffset = 0;
          postsContainer.setAttribute("data-current-offset", "0");
          filterPublications(
            block,
            postsContainer,
            loadMoreWrapper,
            currentCategory,
            currentYear,
            currentRegion,
            "",
            currentOffset,
            postsPerPage,
            true
          );
          // Reset offset after replacing content
          const newPostsCount = postsContainer.querySelectorAll(".news_post").length;
          postsContainer.setAttribute("data-current-offset", newPostsCount.toString());
        });
      }

      // Handle region change (only if region select exists)
      if (regionSelect) {
        regionSelect.addEventListener("change", function () {
          // Clear category and year selects when region is selected (only if category select exists)
          if (this.value) {
            if (categorySelect) categorySelect.value = "";
            if (yearSelect) yearSelect.value = "";
          }
          currentCategory = getEffectiveCategory();
          currentYear = "";
          currentRegion = this.value;
          currentOffset = 0;
          postsContainer.setAttribute("data-current-offset", "0");
          filterPublications(
            block,
            postsContainer,
            loadMoreWrapper,
            currentCategory,
            currentYear,
            currentRegion,
            "",
            currentOffset,
            postsPerPage,
            true
          );
          // Reset offset after replacing content
          const newPostsCount = postsContainer.querySelectorAll(".news_post").length;
          postsContainer.setAttribute("data-current-offset", newPostsCount.toString());
        });
      }

      // Handle Load More button click
      if (loadMoreButton && !loadMoreButton.hasAttribute("data-listener-attached")) {
        loadMoreButton.setAttribute("data-listener-attached", "true");
        loadMoreButton.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Prevent duplicate clicks
          if (this.disabled || this.dataset.loading === "true") {
            return;
          }
          this.dataset.loading = "true";
          
          // Read current filter values from selects or data attributes (for archive pages)
          const catValue = categorySelect ? categorySelect.value : (postsContainer.getAttribute("data-category") || "");
          const yearValue = yearSelect ? yearSelect.value : "";
          const regionValue = regionSelect ? regionSelect.value : (postsContainer.getAttribute("data-region") || "");
          const tagValue = postsContainer.getAttribute("data-tag") || "";
          // Get current offset by counting actual posts displayed (more reliable)
          const currentPostsCount = postsContainer.querySelectorAll(".news_post").length;
          currentOffset = currentPostsCount;
          
          // Use current offset for the request (offset will be updated in success callback)
          filterPublications(
            block,
            postsContainer,
            loadMoreWrapper,
            catValue,
            yearValue,
            regionValue,
            tagValue,
            currentOffset,
            postsPerPage,
            false
          ).finally(() => {
            // Reset loading flag
            if (loadMoreButton) {
              loadMoreButton.dataset.loading = "false";
            }
          });
        });
      } else {
        // Try to find the button again after a short delay (in case it's added dynamically)
        setTimeout(() => {
          const delayedButton = block.querySelector(".load-more-button");
          if (delayedButton && !delayedButton.hasAttribute("data-listener-attached")) {
            delayedButton.setAttribute("data-listener-attached", "true");
            delayedButton.addEventListener("click", function (e) {
              e.preventDefault();
              const catValue = categorySelect ? categorySelect.value : (postsContainer.getAttribute("data-category") || "");
              const yearValue = yearSelect ? yearSelect.value : "";
              const regionValue = regionSelect ? regionSelect.value : (postsContainer.getAttribute("data-region") || "");
              const tagValue = postsContainer.getAttribute("data-tag") || "";
              // Get current offset by counting actual posts displayed (more reliable)
              const currentPostsCount = postsContainer.querySelectorAll(".news_post").length;
              const currentOffset = currentPostsCount;
              filterPublications(
                block,
                postsContainer,
                loadMoreWrapper,
                catValue,
                yearValue,
                regionValue,
                tagValue,
                currentOffset,
                postsPerPage,
                false
              );
            });
          }
        }, 100);
      }
    });
  }

  /**
   * Reinitialize lazy loading for newly loaded content
   */
  function reinitLazyLoading(container) {
    // Try lozad - observe all new lazy elements
    if (typeof lozad !== "undefined") {
      // Find all lazy elements in the container that haven't been loaded yet
      const allLazyElements = container.querySelectorAll(".lazy");

      if (allLazyElements.length > 0) {
        // If we have an existing observer, use it
        if (window.lozadObserver) {
          // Observe all elements in container (lozad handles duplicates)
          allLazyElements.forEach((el) => {
            if (!el.hasAttribute("data-loaded")) {
              window.lozadObserver.observe(el);
            }
          });
        } else {
          // Create new observer and store it globally
          window.lozadObserver = lozad(".lazy", {
            loaded: function (el) {
              el.classList.add("loaded");
              el.setAttribute("data-loaded", "true");
              // Force layout recalculation after image loads
              void el.offsetHeight;
            },
          });
          // Observe all elements
          window.lozadObserver.observe();
        }
      }
    }

    // Try LazyLoad (common library) - use update method
    if (typeof LazyLoad !== "undefined") {
      if (window.lazyLoadInstance) {
        // Update existing instance - this will scan for new elements
        window.lazyLoadInstance.update();
      } else {
        // Create new instance
        window.lazyLoadInstance = new LazyLoad({
          elements_selector: ".lazy",
        });
        window.lazyLoadInstance.update();
      }
    }

    // Try WP Rocket lazy loading (dispatches custom event)
    if (typeof window.dispatchEvent !== "undefined") {
      const event = new CustomEvent("lazyload-update", {
        detail: { container: container },
      });
      window.dispatchEvent(event);
    }

    // Force browser to recalculate layout after a short delay
    setTimeout(() => {
      // Trigger scroll event to help lazy loading libraries detect new content
      window.dispatchEvent(new Event("scroll"));

      // Force layout recalculation by reading offsetHeight
      void container.offsetHeight;

      // Trigger resize event to help browsers recalculate page height
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  /**
   * Filter publications via AJAX
   */
  function filterPublications(
    block,
    container,
    loadMoreWrapper,
    category,
    year,
    region,
    tagId,
    offset,
    postsPerPage,
    replace
  ) {
    // Show loading state
    if (replace) {
      container.style.opacity = "0.5";
      container.style.pointerEvents = "none";
    } else {
      const loadMoreButton = block.querySelector(".load-more-button");
      if (loadMoreButton) {
        loadMoreButton.disabled = true;
        loadMoreButton.textContent = "Loading...";
      }
    }

    // Make AJAX request
    const formData = new FormData();
    formData.append("action", "all_publications_filter");
    formData.append("nonce", allPublicationsAjax.nonce);
    formData.append("category", category);
    formData.append("year", year);
    formData.append("region", region);
    formData.append("tag_id", tagId || "");
    formData.append("offset", offset);
    formData.append("posts_per_page", postsPerPage);

    return fetch(allPublicationsAjax.ajaxurl, {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.success) {
          if (replace) {
            container.innerHTML = data.data.html;
            // Update offset after replacing content
            const newPostsCount = container.querySelectorAll(".news_post").length;
            container.setAttribute("data-current-offset", newPostsCount.toString());
            // Reinitialize lazy loading for new content
            reinitLazyLoading(container);
            // No scrolling - just replace content and let user stay where they are
          } else {
            // Append new posts
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = data.data.html;
            const newPosts = tempDiv.querySelectorAll(".news_post");

            newPosts.forEach((post) => {
              container.appendChild(post);
            });

            // Update offset after successfully loading posts - count all posts to be accurate
            const totalPostsCount = container.querySelectorAll(".news_post").length;
            container.setAttribute("data-current-offset", totalPostsCount.toString());

            // Reinitialize lazy loading for newly appended content
            reinitLazyLoading(container);

            // Force page height recalculation after images have time to load
            // This ensures the scroll area extends properly
            setTimeout(() => {
              // Force layout recalculation by reading dimensions
              void container.offsetHeight;
              void document.body.offsetHeight;
              void document.documentElement.offsetHeight;

              // Trigger resize event to help browsers recalculate
              window.dispatchEvent(new Event("resize"));
            }, 500);

            // No scrolling - just append content and let user stay where they are
          }

          // Show/hide Load More button
          let wrapper =
            loadMoreWrapper || block.querySelector(".load-more-wrapper");
          if (!wrapper && data.data.has_more) {
            // Create wrapper if it doesn't exist
            wrapper = document.createElement("div");
            wrapper.className = "load-more-wrapper";
            const button = document.createElement("button");
            button.className = "load-more-button grey_button";
            button.type = "button";
            button.textContent = "Load more";
            wrapper.appendChild(button);
            block.querySelector(".inner").appendChild(wrapper);

            // Add click handler
            button.addEventListener("click", function () {
              const categorySelect = block.querySelector(
                '.filter-select[data-filter-type="category"]'
              );
              const yearSelect = block.querySelector(
                '.filter-select[data-filter-type="year"]'
              );
              const regionSelect = block.querySelector(
                '.filter-select[data-filter-type="region"]'
              );
              // Read filter values from select or data attributes (for archive pages)
              const currentCategory = categorySelect
                ? categorySelect.value
                : (container.getAttribute("data-category") || "");
              const currentYear = yearSelect ? yearSelect.value : "";
              const currentRegion = regionSelect ? regionSelect.value : (container.getAttribute("data-region") || "");
              const currentTagId = container.getAttribute("data-tag") || "";
              // Get current offset by counting actual posts displayed (more reliable)
              const currentPostsCount = container.querySelectorAll(".news_post").length;
              const currentOffset = currentPostsCount;
              // Use current offset for the request (offset will be updated in success callback)
              filterPublications(
                block,
                container,
                wrapper,
                currentCategory,
                currentYear,
                currentRegion,
                currentTagId,
                currentOffset,
                postsPerPage,
                false
              );
            });
          }

          if (wrapper) {
            if (data.data.has_more) {
              wrapper.style.display = "flex";
              const button = wrapper.querySelector(".load-more-button");
              if (button) {
                button.disabled = false;
                button.textContent = "Load more";
              }
            } else {
              wrapper.style.display = "none";
            }
          }
        } else {
          console.error("Error filtering publications:", data.data.message);
          if (replace) {
            container.innerHTML =
              '<p class="no-posts">Error loading publications. Please try again.</p>';
          }
        }
      })
      .catch((error) => {
        console.error("AJAX error:", error);
        if (replace) {
          container.innerHTML =
            '<p class="no-posts">Error loading publications. Please try again.</p>';
        }
      })
      .finally(() => {
        // Remove loading state
        container.style.opacity = "1";
        container.style.pointerEvents = "auto";

        const loadMoreButton = block.querySelector(".load-more-button");
        if (loadMoreButton) {
          loadMoreButton.disabled = false;
          loadMoreButton.textContent = "Load more";
        }
      });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllPublications);
  } else {
    initAllPublications();
  }
})();
